import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let discussParallax = document.querySelector('#discusParallax');

if(discussParallax) {
    setTimeout(discussParallaxFn, 200)
}

function discussParallaxFn() {
    // ScrollTrigger.refresh(true);

    gsap.to(discussParallax, {
        scrollTrigger: {
            trigger: '.discuss',
            scrub: 1.2,
            // markers: true,
            start: "top 100%",
            // end: "bottom 15%",
        },
        y: -200,
    });


}


